<template>
  <div>
    <SubTitleView>{{ $t("profilePage.etablissement.identite") }}</SubTitleView>
    <InputWithValidation
      v-model="localEtablissement.codeEtablissement"
      rules="required"
      :label="$t(`profilePage.etablissement.codeEtablissement`)"
      :placeholder="$t(`profilePage.etablissement.placeholder.codeEtablissement`)"
      :disabled="true"
      :group="validationGroup"
      vid="codeEtablissement"
      :control-action="userCanChange"
      :control-right="true"
    >
      <b-button
        v-if="userCanChange"
        icon-left="save"
        type="is-dark"
        :disabled="readonly"
        @click="changeEtablissement"
      >
        {{ $t("profilePage.etablissement.change.change") }}
      </b-button>
    </InputWithValidation>
    <InputWithValidation
      v-model="localEtablissement.nom"
      rules="required"
      :label="$t(`profilePage.etablissement.nom`)"
      :placeholder="$t(`profilePage.etablissement.placeholder.nom`)"
      :disabled="readonly"
      :group="validationGroup"
      vid="nomEtablissement"
      @manual-change="updateEtablissementIdentite"
    />
    <InputWithValidation
      v-model="localEtablissement.nature"
      rules="required"
      :label="$t(`profilePage.etablissement.nature`)"
      :placeholder="$t(`profilePage.etablissement.placeholder.nature`)"
      :disabled="readonly"
      :group="validationGroup"
      vid="natureEtablissement"
      @manual-change="updateEtablissementIdentite"
    />
    <InputWithValidation
      v-model="localEtablissement.statut"
      rules="required"
      :label="$t(`profilePage.etablissement.statut`)"
      :placeholder="$t(`profilePage.etablissement.placeholder.statut`)"
      :disabled="readonly"
      :group="validationGroup"
      vid="statutEtablissement"
      @manual-change="updateEtablissementIdentite"
    />
    <InputWithValidation
      v-if="localEtablissement.statut !== statuts.PUBLIC"
      v-model="localEtablissement.typeContrat"
      :disabled="readonly"
      rules="required"
      :label="$t(`profilePage.etablissement.typeContrat`)"
      :placeholder="$t(`profilePage.etablissement.placeholder.typeContrat`)"
      :group="validationGroup"
      vid="typeContratEtablissement"
      @manual-change="updateEtablissementIdentite"
    />
    <InputWithValidation
      v-model="localEtablissement.sirenSiret"
      :label="$t(`profilePage.etablissement.siret`)"
      :placeholder="$t(`profilePage.etablissement.placeholder.siret`)"
      :disabled="readonly"
      :group="validationGroup"
      vid="siretEtablissement"
      @manual-change="updateEtablissementIdentite"
    />
    <InputWithValidation
      v-model="localEtablissement.departement"
      rules="required"
      :label="$t(`profilePage.etablissement.departement`)"
      :placeholder="$t(`profilePage.etablissement.placeholder.departement`)"
      :disabled="readonly"
      :group="validationGroup"
      vid="departementEtablissement"
      @manual-change="updateEtablissementIdentite"
    />
    <InputWithValidation
      v-model="localEtablissement.codeDepartement"
      rules="required"
      :label="$t(`profilePage.etablissement.codeDepartement`)"
      :placeholder="$t(`profilePage.etablissement.placeholder.codeDepartement`)"
      :group="validationGroup"
      vid="codeDptEtablissement"
      disabled
      @manual-change="updateEtablissementIdentite"
    />
    <InputWithValidation
      v-model="localEtablissement.academie"
      rules="required"
      :label="$t(`profilePage.etablissement.academie`)"
      :placeholder="$t(`profilePage.etablissement.placeholder.academie`)"
      :group="validationGroup"
      vid="academieEtablissement"
      disabled
      @manual-change="updateEtablissementIdentite"
    />
    <InputWithValidation
      v-if="localEtablissement.grae"
      v-model="localEtablissement.grae.region"
      rules="required"
      :label="$t(`profilePage.etablissement.region`)"
      :placeholder="$t(`profilePage.etablissement.placeholder.region`)"
      :group="validationGroup"
      vid="regionEtablissement"
      disabled
      @manual-change="updateEtablissementIdentite"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"
import SubTitleView from "@/views/commons/SubTitleView.vue"
import { EtablissementDTO } from "@/model/bean/GeneratedDTOs"
import { STATUT_ETABLISSEMENT } from "@/model/bean/EnumHelper"
import { InfoReportingService } from "@/services/log/InfoReportingService"
import { BButton } from "buefy"

export default defineComponent({
  name: "EtablissementIdentiteDetails",
  components: {
    InputWithValidation,
    SubTitleView,
    BButton,
  },
  props: {
    etablissement: {
      type: Object as PropType<EtablissementDTO>,
      required: true,
    },
    userCanChange: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    validationGroup: String,
  },

  emits: ["change-etablissement", "update-etablissement"],
  data() {
    return {
      localEtablissement: { ...this.etablissement } as EtablissementDTO,
      infoReportingService: InfoReportingService.INSTANCE,
      isChanging: false,
      statuts: STATUT_ETABLISSEMENT,
    }
  },
  watch: {
    etablissement: {
      handler(newVal: EtablissementDTO) {
        this.localEtablissement = { ...newVal }
      },
      deep: true,
    },
  },
  methods: {
    changeEtablissement(): void {
      this.infoReportingService.dialog(
        this.$t("profilePage.etablissement.change.confirmation").toString(),
        this.$t("profilePage.etablissement.change.are-you-sure").toString(),
        this.$t("profilePage.etablissement.change.save").toString(),
        () => this.$emit("change-etablissement"),
        "is-warning",
      )
    },

    updateEtablissementIdentite(): void {
      this.$emit("update-etablissement", this.localEtablissement)
    },
  },
})
</script>
